import { createContext, useContext, ReactNode } from "react";
import {
  useUnreadNotifications,
  EMPTY_SIDEBAR_UNREADS,
  type UnreadConversationPreview,
  type SidebarUnreadMaps,
} from "@/hooks/useUnreadNotifications";

interface UnreadContextType {
  unreadCount: number;
  unreadPreviews: UnreadConversationPreview[];
  sidebarUnreads: SidebarUnreadMaps;
}

const UnreadContext = createContext<UnreadContextType | undefined>(undefined);

const DISABLED_VALUE: UnreadContextType = {
  unreadCount: 0,
  unreadPreviews: [],
  sidebarUnreads: EMPTY_SIDEBAR_UNREADS,
};

export function UnreadProvider({
  workspaceId,
  disabled = false,
  children,
}: {
  workspaceId: string | null;
  disabled?: boolean;
  children: ReactNode;
}) {
  const { unreadCount, unreadPreviews, sidebarUnreads } = useUnreadNotifications(
    workspaceId,
    disabled,
  );
  return (
    <UnreadContext.Provider
      value={disabled ? DISABLED_VALUE : { unreadCount, unreadPreviews, sidebarUnreads }}
    >
      {children}
    </UnreadContext.Provider>
  );
}

export function useUnread(): UnreadContextType {
  const ctx = useContext(UnreadContext);
  if (ctx === undefined) {
    throw new Error("useUnread must be used within UnreadProvider");
  }
  return ctx;
}
